import React from 'react'

function ShowFeedback() {
  return (
    <div>ShowFeedback</div>
  )
}

export default ShowFeedback